import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
// @mui
import { useTheme, Box, Table, TextField, TableBody, Stack, TableContainer, tableCellClasses, InputAdornment, tablePaginationClasses, Container, Button } from '@mui/material';
import { RouterLink } from '../../../routes/components/index.js';
import CustomBreadcrumbs from '../../../components/custom-breadcrumbs/index.js';
import { useSettingsContext } from '../../../components/settings/index.js';
import { useSnackbar } from '../../../components/snackbar/index.js';
// components
import Iconify from 'src/components/iconify';
import {
  TableHeadCustom,
  TablePaginationCustom,
  useTable
} from 'src/components/table';
//
import FileManagerTableRow from './file-manager-table-row.js';
import { GET_ALL_USERS } from "../../../graphql/modules/users.js";
import { GET_ALLFOLDER, CREATE_FOLDER, UPDATE_FOLDER, DELETE_FOLDER } from "../../../graphql/modules/_client/library.js";
import { useQuery, useMutation } from "@apollo/react-hooks";
import FileManagerNewFolderDialog from "./file-manager-new-folder-dialog.js"
import { useBoolean } from 'src/hooks/use-boolean';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'name', label: 'Name' },
  { id: 'sharedBy', label: 'Owner', width: 140 },
  { id: 'modifiedDate', label: 'Modified', width: 140 },
  { id: 'isIndividual', label: 'Access Type', align: 'right', width: 140 },
  { id: '', width: 88 },
];

// ----------------------------------------------------------------------

export function LibraryListView({
  tableData,
  notFound,
  onDeleteRow,
  dataFiltered,
  onOpenConfirm,
}) {
  const fullName = useSelector((state) => state?.auth?.user?.fullName);
  const shareId = useSelector((state) => state?.auth?.user?._id);
  const userObject = useSelector((state) => state?.auth?.user);
  const userRole = useSelector((state) => state?.auth?.user?.userRole);
  const company = useSelector((state) => state?.auth?.company);
  const [searchText, setSearch] = useState("");
  const [searchUser, setSearchUser] = useState("");
  const [results, setResults] = useState(null);
  const [allusers, setAllUser] = useState([]);
  const [formFolder, setFormFolder] = useState({
    name: '',
    isIndividual: false,
    accessibleToUsers: [],
    accessibleToGroups: [],
    files: [],
    createdBy: '',
    createdDate: new Date(),
    modifiedBy: '',
    modifiedDate: new Date(),
    sharedBy: userObject,
    uploadFiles: null
  });
  const settings = useSettingsContext();
  const theme = useTheme();
  const table = useTable();
  const upload = useBoolean();
  const { enqueueSnackbar } = useSnackbar();

  const [CreateFolderMutation] = useMutation(CREATE_FOLDER);
  const [UpdateFolderMutation] = useMutation(UPDATE_FOLDER);
  const [DeleteFolderMutation] = useMutation(DELETE_FOLDER);

  const { data, loading, error, refetch } = useQuery(GET_ALLFOLDER, {
    variables: {
      limit: table?.rowsPerPage,
      offset: table?.page,
      searchText: searchText,
      companyName: company,
      order: table.order || 'desc',
      orderBy: table.orderBy || 'createdDate',
      userId: [shareId],
      userRole: userRole,
      sharedBy: shareId
    },
    fetchPolicy: "cache-and-network",
  });

  const { data: alluser, loading: loadinguser } = useQuery(GET_ALL_USERS, {
    variables: {
      limit: table?.rowsPerPage,
      offset: table?.page,
      companyName: company,
      searchText: searchUser,
      filter: "All",
      order: table.order || 'asc',
      orderBy: table.orderBy || 'fullname',
    },
    fetchPolicy: "cache-and-network",
  });

  useEffect(() => {
    if (data) {
      setResults(data?.getAllFolder);
    }
  }, [data])

  useEffect(() => {
    if (alluser) {
      setAllUser(alluser.getUsers)
    }
  }, [alluser, searchUser])


  const handleCreate = async () => {
    if (formFolder?.isIndividual) {
      formFolder.accessibleToUsers.push(userObject);
      const { data: { createFolder } } = await CreateFolderMutation({
        variables: {
          companyName: company,
          fullName: fullName,
          data: formFolder
        }
      });
      if (createFolder?.success) {
        enqueueSnackbar('Successfully Created.', { variant: 'success' });
        refetch();
        handleCloseDialog();
      } else {
        enqueueSnackbar('Error: unable to save the folder. ', { variant: 'error' });
      }

    } else {
      // formFolder.accessibleToGroups = [
      //   ...new Set([...formFolder.accessibleToGroups, ...userObject.userRole])
      // ];
      const { data: { createFolder } } = await CreateFolderMutation({
        variables: {
          companyName: company,
          fullName: fullName,
          data: formFolder
        }
      });
      if (createFolder?.success) {
        enqueueSnackbar('Successfully Created.', { variant: 'success' });
        refetch();
        handleCloseDialog();
      } else {
        enqueueSnackbar('Error: unable to save the folder. ', { variant: 'error' });
      }

    }
  }

  const handleUpdate = async () => {
    try{
    if (formFolder?.isIndividual) {
      // formFolder.accessibleToUsers.push(userObject);
      formFolder.accessibleToUsers = [
          ...formFolder.accessibleToUsers.filter(u => u._id !== userObject._id),
          userObject
        ];
      const { data: { updateFolder } } = await UpdateFolderMutation({
        variables: {
          companyName: company,
          fullName: fullName,
          id: formFolder?._id,
          data: {
            name: formFolder?.name,
            accessibleToGroups: formFolder?.accessibleToGroups,
            accessibleToUsers: formFolder?.accessibleToUsers,
            sharedBy: userObject,
            modifiedDate: new Date(),
            modifiedBy: fullName,
            isIndividual: formFolder?.isIndividual,
            files: formFolder?.files,
            uploadFiles: formFolder?.uploadFiles
          },

        }
      });
      if (updateFolder?.success) {
        enqueueSnackbar('Successfully Updated.', { variant: 'success' });
        refetch();
        handleCloseDialog();
      } else {
        enqueueSnackbar(updateFolder?.message, { variant: 'error' });
      }

    } else {
      formFolder.accessibleToGroups = [
        ...new Set([...formFolder.accessibleToGroups, ...userObject.userRole])
      ];
      const { data: { updateFolder } } = await UpdateFolderMutation({
        variables: {
          companyName: company,
          fullName: fullName,
          id: formFolder?._id,
          data: {
            name: formFolder?.name,
            accessibleToGroups: formFolder?.accessibleToGroups,
            accessibleToUsers: formFolder?.accessibleToUsers,
            sharedBy: userObject,
            modifiedDate: new Date(),
            modifiedBy: fullName,
            isIndividual: formFolder?.isIndividual,
            files: formFolder?.files,
            uploadFiles: formFolder?.uploadFiles
          },
        }
      });
      if (updateFolder?.success) {
        enqueueSnackbar('Successfully Updated.', { variant: 'success' });
        handleCloseDialog();
        refetch();
      } else {
        enqueueSnackbar(updateFolder?.msg, { variant: 'error' });
      }

    }
   } catch(err){
    enqueueSnackbar('Error: unable to save the folder. ', { variant: 'error' });
   }

  }

  const handleEditOpen = async (row) => {
    setFormFolder(row)
    upload.onTrue()
  }

  const handleDelete = async (row) => {
    const { data: { deleteFolder } } = await DeleteFolderMutation({
      variables: {
        companyName: company,
        fullName: fullName,
        id: row?._id
      }
    });

    if (deleteFolder?.success) {
      enqueueSnackbar('Successfully deleted.', { variant: 'success' });
      refetch();
      upload.onFalse();
    } else {
      enqueueSnackbar('Error: unable to deleted the folder. ', { variant: 'error' });
    }
  }

  const handleCloseDialog = async () => {
    setFormFolder({
      name: '',
      isIndividual: false,
      accessibleToUsers: [],
      accessibleToGroups: [],
      files: [],
      createdBy: '',
      createdDate: new Date(),
      modifiedBy: '',
      modifiedDate: new Date(),
      sharedBy: userObject
    })

    upload.onFalse();
  }

  const handleSearch = (e) => {
    setSearch(e.target.value)
  }

   const renderFilters = (
    <Stack
      spacing={2}
      direction={{ xs: 'column', md: 'row' }}
      alignItems={{ xs: 'flex-end', md: 'center' }}
    >
      
     <TextField
      value={searchText}
      onChange={(e) => handleSearch(e)}
      placeholder="Search..."
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Iconify icon="eva:search-fill" sx={{ color: 'text.disabled' }} />
          </InputAdornment>
        ),
      }}
      sx={{
        width: { xs: 1, md: 390 },
      }}
    />

    </Stack>
  );


  return (
    <Container maxWidth={settings.themeStretch ? false : 'xl'}>
      <CustomBreadcrumbs
        heading={`Library Management`}
        links={[
          { name: 'Library' },
        ]}
        action={
          <>
            <Button
              componet={RouterLink}
              variant="contained"
              onClick={upload.onTrue}
              startIcon={<Iconify icon="mingcure:add-line" />}
            >
              Create
            </Button>
          </>
        }
      />

              <Stack
          spacing={2.5}
          sx={{
            my: { xs: 3, md: 5 },
          }}
        >
          {renderFilters}
        </Stack>

      <Box
        sx={{
          position: 'relative',
          m: theme.spacing(-2, -3, -3, -3),
        }}
      >
        {/* <TableSelectedAction
          dense={dense}
          numSelected={selected.length}
          rowCount={tableData.length}
          onSelectAllRows={(checked) =>
            onSelectAllRows(
              checked,
              tableData.map((row) => row.id)
            )
          }
          action={
            <>
              <Tooltip title="Share">
                <IconButton color="primary">
                  <Iconify icon="solar:share-bold" />
                </IconButton>
              </Tooltip>

              <Tooltip title="Delete">
                <IconButton color="primary" onClick={onOpenConfirm}>
                  <Iconify icon="solar:trash-bin-trash-bold" />
                </IconButton>
              </Tooltip>
            </>
          }
          sx={{
            pl: 1,
            pr: 2,
            top: 16,
            left: 24,
            right: 24,
            width: 'auto',
            borderRadius: 1.5,
          }}
        /> */}

        <TableContainer
          sx={{
            p: theme.spacing(0, 3, 3, 3),
          }}
        >
          <Table
            size={table.dense ? 'small' : 'medium'}
            sx={{
              minWidth: 960,
              borderCollapse: 'separate',
              borderSpacing: '0 16px',
            }}
          >
            <TableHeadCustom
              order={table.order}
              orderBy={table.orderBy}
              headLabel={TABLE_HEAD}
              rowCount={tableData?.length}
              // numSelected={selected.length}
              onSort={table.onSort}
              // onSelectAllRows={(checked) =>
              //   onSelectAllRows(
              //     checked,
              //     tableData.map((row) => row.id)
              //   )
              // }
              sx={{
                [`& .${tableCellClasses.head}`]: {
                  '&:first-of-type': {
                    borderTopLeftRadius: 12,
                    borderBottomLeftRadius: 12,
                  },
                  '&:last-of-type': {
                    borderTopRightRadius: 12,
                    borderBottomRightRadius: 12,
                  },
                },
              }}
            />

            <TableBody>
              {results?.results?.map((row) => (
                <FileManagerTableRow
                  key={row?.id}
                  row={row}
                  userId={userObject?._id}
                  // onViewRow={() => handleViewAccount(row)}
                  onDeleteRow={() => handleDelete(row)}
                  onEditRow={() => handleEditOpen(row)}
                />
              ))}



            </TableBody>
          </Table>
        </TableContainer>
      </Box>

      <TablePaginationCustom
        count={results?.count}
        page={table.page}
        rowsPerPage={table.rowsPerPage}
        onPageChange={table.onChangePage}
        onRowsPerPageChange={table.onChangeRowsPerPage}
        dense={table.dense}
      />
      <FileManagerNewFolderDialog onCreate={handleCreate} onUpdate={handleUpdate} open={upload.value} onClose={() => handleCloseDialog()} allusers={allusers?.results} setSearchUser={setSearchUser} setFormFolder={setFormFolder} formFolder={formFolder} />
    </Container>
  );
}

LibraryListView.propTypes = {
  dataFiltered: PropTypes.array,
  notFound: PropTypes.bool,
  onDeleteRow: PropTypes.func,
  onOpenConfirm: PropTypes.func,
  table: PropTypes.object,
  tableData: PropTypes.array,
};
